/**
 * @flow
 * @relayHash e9409e5d427948566f3ae1e130ce640b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type FormJobCategoryTypeField_viewer$ref = any;
export type FormJobCategoryTypeFieldRefetchQueryVariables = {|
  businessTypeName?: ?string
|};
export type FormJobCategoryTypeFieldRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: FormJobCategoryTypeField_viewer$ref
  |}
|};
export type FormJobCategoryTypeFieldRefetchQuery = {|
  variables: FormJobCategoryTypeFieldRefetchQueryVariables,
  response: FormJobCategoryTypeFieldRefetchQueryResponse,
|};
*/


/*
query FormJobCategoryTypeFieldRefetchQuery(
  $businessTypeName: String
) {
  viewer {
    ...FormJobCategoryTypeField_viewer_3rjcdW
    id
  }
}

fragment FormJobCategoryTypeField_viewer_3rjcdW on Viewer {
  jobCategoryTypes(businessTypeName: $businessTypeName) {
    id
    plainId
    name
    label
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "businessTypeName",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "businessTypeName",
    "variableName": "businessTypeName"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FormJobCategoryTypeFieldRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "FormJobCategoryTypeField_viewer",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "FormJobCategoryTypeFieldRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobCategoryTypes",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "JobCategoryType",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "plainId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "label",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "FormJobCategoryTypeFieldRefetchQuery",
    "id": null,
    "text": "query FormJobCategoryTypeFieldRefetchQuery(\n  $businessTypeName: String\n) {\n  viewer {\n    ...FormJobCategoryTypeField_viewer_3rjcdW\n    id\n  }\n}\n\nfragment FormJobCategoryTypeField_viewer_3rjcdW on Viewer {\n  jobCategoryTypes(businessTypeName: $businessTypeName) {\n    id\n    plainId\n    name\n    label\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e3eedc59f0563329f25515358a73c217';
module.exports = node;
